import { Navigate, useLocation } from "react-router-dom";
import { useAuth, useIsAdmin } from "@/lib/auth";

/**
 * Route guard for admin-only pages.
 * Requires authentication + admin role in app_metadata.
 */
export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const isAdmin = useIsAdmin();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-pink-dark border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    const redirectPath = `${location.pathname}${location.search}`;
    return (
      <Navigate
        to={`/app/auth/login?redirect=${encodeURIComponent(redirectPath)}`}
        replace
      />
    );
  }

  if (!isAdmin) {
    return <Navigate to="/app/dashboard/home" replace />;
  }

  return <>{children}</>;
}
